import { useMemo } from 'react'

export const useOdometerFormat = (amount: number) => useMemo(() => {
    const str = String(amount)

    const [, intPart = '', decimalPart = ''] = str.match(/^(\d+)(?:\.(\d+))?$/) || []

    const intDigits = intPart.length + 1
    const decimals = decimalPart.length + 1

    const format = decimals
      ? `(${intPart.replace(/\d/g, 'd')}).${'d'.repeat(decimals)}`
      : `(${intPart.replace(/\d/g, 'd')})`

    const integerBase = 10 ** (intDigits - 1)

    const fractionalStep = decimals ? 10 ** -decimals : 0

    const decimalStep = decimals ? Number((integerBase + fractionalStep).toFixed(decimals)) : integerBase

    return {
      value: amount,
      format,
      decimalStep,
    }
  }, [amount])
